import { calendarRoute } from '@/views/calendar_route';
// import { addPermissionsToRoute } from '@qsrsoft/myq-core';

const routes = [
  {
    name: 'Business Unit',
    icon: 'mdi-store-outline',
    path: '/reports/mcd/businessUnit/',
    children: [
      {
        path: '/businessUnitBI',
        name: 'Business Unit BI',
        meta: { id: 'bu-dashboard', hidePageHeader: true },
        component: () =>
          import('../mcd/businessUnit/quickSight/QuickSightDashboard.vue'),
      },
      {
        path: '/businessUnitBI/customRequestForm',
        name: 'Custom Request Form',
        meta: { id: 'bu-reports' },
        component: () =>
          import('../mcd/businessUnit/quickSight/CustomRequestForm.vue'),
      },
      {
        path: '/customIncentive',
        name: 'Custom Incentive',
        meta: { id: 'bu-incentives' },
        component: () => import('./incentiveWizard/CustomIncentive.vue'),
      },
    ],
  },
  calendarRoute,
];

export default routes;
